module.exports = __webpack_public_path__ + "img/w-right-arrow.cc6fc1b3.png";